


























import { Component, Vue, Prop, Provide } from 'vue-property-decorator'
import router from './../main'

@Component
export default class PersonalMenu extends Vue {
  public menu = router
  public selectedKeys: any = ['download']
  public openKeys: any = ['personal']
  public handleSelect(e) {
    this.$router.push(e.key)
  }
  public created() {
    this.selectedKeys = [this.$route.meta.name]
  }
  private get subjectId() {
    return this.$store.state.subject.value
  }
}
